(() => {
  const ZOOM_LEVEL = 3;
  const STYLE_ID = 'rayolo-product-zoom-style';

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      product-gallery[data-rayolo-zoom-ready="true"] .product-gallery__media[data-media-type="image"] img {
        cursor: zoom-in;
      }

      .rayolo-product-zoom-button {
        position: absolute;
        right: 16px;
        bottom: 16px;
        z-index: 4;
        width: 46px;
        height: 46px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(168, 135, 98, 0.45);
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.94);
        color: #242321;
        box-shadow: 0 3px 14px rgba(0, 0, 0, 0.14);
        -webkit-backdrop-filter: blur(8px);
        backdrop-filter: blur(8px);
        cursor: zoom-in;
        transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
      }

      .rayolo-product-zoom-button:hover {
        transform: scale(1.05);
        background: #fff;
        box-shadow: 0 5px 18px rgba(0, 0, 0, 0.18);
      }

      .rayolo-product-zoom-button:focus-visible {
        outline: 2px solid #A88762;
        outline-offset: 3px;
      }

      .rayolo-product-zoom-button svg {
        width: 22px;
        height: 22px;
        pointer-events: none;
      }

      @media screen and (max-width: 699px) {
        .rayolo-product-zoom-button {
          right: 12px;
          bottom: 12px;
          width: 44px;
          height: 44px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function visibleImageMedia(gallery) {
    return Array.from(
      gallery.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden])')
    );
  }

  function openMedia(gallery, media) {
    const items = visibleImageMedia(gallery);
    const index = Math.max(0, items.indexOf(media));

    if (typeof gallery.openZoom === 'function') {
      gallery.openZoom(index);
      return;
    }

    gallery.dispatchEvent(new CustomEvent('lightbox:open', {
      bubbles: true,
      detail: { index }
    }));
  }

  function setupGallery(gallery) {
    if (!gallery || gallery.dataset.rayoloZoomReady === 'true') return;

    const originallyAllowedZoom = gallery.hasAttribute('allow-zoom');
    gallery.dataset.rayoloZoomReady = 'true';

    if (!originallyAllowedZoom) {
      gallery.setAttribute('allow-zoom', String(ZOOM_LEVEL));
      gallery.addEventListener('lightbox:open', (event) => {
        if (typeof gallery.openZoom === 'function') {
          gallery.openZoom(event.detail?.index ?? 0);
        }
      });
    }

    gallery.addEventListener('click', (event) => {
      const image = event.target.closest?.('.product-gallery__media[data-media-type="image"] img');
      if (!image || !gallery.contains(image)) return;

      const media = image.closest('.product-gallery__media');
      if (!media) return;

      event.preventDefault();
      event.stopPropagation();
      openMedia(gallery, media);
    }, true);

    const wrapper = gallery.querySelector('.product-gallery__media-list-wrapper');
    if (!wrapper || wrapper.querySelector('.rayolo-product-zoom-button')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'rayolo-product-zoom-button';
    button.setAttribute('aria-label', "Agrandir l’image");
    button.innerHTML = `
      <svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
        <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" stroke-width="1.8"/>
        <path d="M15.3 15.3 20 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M10.5 7.8v5.4M7.8 10.5h5.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    `;

    const syncButton = () => {
      const carousel = gallery.querySelector('media-carousel');
      const selected = carousel?.selectedSlide || carousel?.querySelector('.is-selected') || carousel?.firstElementChild;
      button.hidden = !!selected && selected.getAttribute('data-media-type') !== 'image';
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const carousel = gallery.querySelector('media-carousel');
      const selected = carousel?.selectedSlide || carousel?.querySelector('.is-selected') || visibleImageMedia(gallery)[0];
      if (selected?.getAttribute('data-media-type') === 'image') {
        openMedia(gallery, selected);
      }
    });

    gallery.addEventListener('carousel:change', syncButton);
    wrapper.appendChild(button);
    syncButton();
  }

  async function init() {
    installStyles();
    await customElements.whenDefined('product-gallery');

    document.querySelectorAll('product-gallery').forEach(setupGallery);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('product-gallery')) setupGallery(node);
          node.querySelectorAll?.('product-gallery').forEach(setupGallery);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
